// extracted by mini-css-extract-plugin
module.exports = {"trrdd":"trrdd___2byGK","antCol":"antCol___1-Vt7","antRow":"antRow___1bti1"};